import { keyframes } from '@mui/material/styles';
// Common styles for reuse across components
export const inputs = {
    customFieldsBox: {
        backgroundColor: '#EAEAF0',
        borderBottom: '2px solid',
        borderColor: '#D3D3DE',
        pb: 1
    }
};

export const AI_BLUE = '#00004B';
export const AI_ORANGE = '#F7914B';

export const rotateGlow = keyframes`
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
`;


// Commented out old highlights - will revisit in future to create more subtle highlight that works better with MUI components
// Keeping the variable here as it is passed down and used to conditionally apply styles in multiple components, but the actual styles have been removed for now to avoid conflicts with MUI's default styles.
export const aiHighlightSx = {
    // '& .MuiOutlinedInput-root': {
    //     '& fieldset': {
    //         border: '2px solid transparent',
    //         backgroundImage: 'linear-gradient(white, white), linear-gradient(90deg, #00004B, #F7914B, #00004B)',
    //         backgroundOrigin: 'border-box',
    //         backgroundClip: 'padding-box, border-box',
    //         backgroundSize: '100% 100%, 200% 100%',
    //     },
    //     '& .MuiInputBase-input': {
    //         color: '#4B4E65',
    //         position: 'relative',
    //         zIndex: 1,
    //     },
    //     '& .MuiInputAdornment-root': {
    //         position: 'relative',
    //         zIndex: 1, // Ensure icons are visible over border backgrounds
    //     },
    //     '& .MuiSelect-icon': {
    //         zIndex: 1, // Ensure dropdown arrow is visible over border backgrounds
    //         // Removed position: relative to maintain standard MUI absolute positioning
    //     },
    //     '&:hover fieldset': {
    //         backgroundImage: 'linear-gradient(white, white), linear-gradient(90deg, #00004B, #F7914B, #00004B)',
    //         border: '2px solid transparent',
    //     },
    //     '&.Mui-focused fieldset': {
    //         backgroundImage: 'linear-gradient(white, white), linear-gradient(90deg, #00004B, #F7914B, #00004B)',
    //         border: '2px solid transparent',
    //     },
    // },
    // '& .MuiInputLabel-root': {
    //     color: AI_BLUE,
    //     fontWeight: 700,
    // },
    // '& .MuiInputLabel-root.MuiInputLabel-shrink': {
    //     background: `linear-gradient(90deg, ${AI_BLUE}, #1a1a5e)`,
    //     color: 'white',
    //     padding: '1px 4px',
    //     mt: '4px', // Adjust as needed to align with the notch
    //     borderRadius: '4px',
    //     fontSize: '0.70rem',
    //     fontWeight: 500,
    //     letterSpacing: '0.5px',
    //     zIndex: 2,
    //     // Aligns precisely with the notch for small TextFields
    //     transform: 'translate(14px, -10px) scale(1)', 
    //     '&.Mui-focused': {
    //         color: 'white',
    //     }
    // },
};

export const aiIconSx = {
    color: AI_BLUE,
    '& .MuiSvgIcon-secondaryColor': { 
        color: AI_ORANGE, 
        opacity: 1 
    }
};

export const AI_PURPLE = '#9C27B0';
export const AI_PURPLE_DARK = '#7B1FA2';
